import { useEffect, useState } from 'react'
import { useHistory } from 'react-router'
import { useContextSelector } from 'use-context-selector'

import { FormContext } from 'components/formKit/Form'
import { useOpenModal } from 'components/uiKit/Modal'
import { EMPTY_OBJECT } from 'constants/commonConstans'

import FormModalExit from '../FormModalExit'

const UseFormConfirmExit: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false)
  const history = useHistory()
  const isDirty = useContextSelector(FormContext, (context) => context.isDirty)
  // const loading = useContextSelector(FormContext, (context) => context.submitting)
  const submit = useContextSelector(FormContext, (context) => context.submit)

  const modalExit = useOpenModal(FormModalExit, EMPTY_OBJECT) //{ /* loading */ }

  useEffect(() => {
    if (isDirty && !isOpen) {
      const unblock = history.block((location) => {
        modalExit.open({ unblock, submit, location, onCloseModal: () => setIsOpen(false) })
        setIsOpen(true)
        return false
      })
      return () => unblock()
    }
    return () => {}
    // when we use 'open' it again cause useEffect with new 'open' in
    // also props in useOpenModal are not updating :(
  }, [submit, modalExit, history, isDirty, isOpen])

  useEffect(() => {
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      if (isDirty) {
        e.preventDefault()
        e.returnValue = ''
      }
    }
    window.addEventListener('beforeunload', handleBeforeUnload)
    return () => window.removeEventListener('beforeunload', handleBeforeUnload)
  }, [isDirty])

  return null
}

export default UseFormConfirmExit
